import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  GreenStatusMessage,
  BlueStatusMessage,
  RedStatusMessage,
} from '../../common/components/styledComponents';

interface StatusMessageProps {
  /**
   * PENDING, // 등록승인
   * DECLINED, // 등록거절
   * COMPLETED, // 등록완료
   * FAILED, // 등록실패
   * RESERVED, // 등록 예약
   */
  // TODO: 서버 구현되면 status 맞춰주기
  status: 'PENDING' | 'DECLINED' | 'COMPLETED' | 'FAILED' | 'RESERVED';
}
export const StatusMessage = (props: StatusMessageProps) => {
  const { status } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.mypage.uploadedImages.table.statusMessage',
  });

  switch (status) {
    case 'PENDING':
      return <GreenStatusMessage>{`${t('pending')}`}</GreenStatusMessage>;
    case 'DECLINED':
      return <RedStatusMessage>{`${t('declined')}`}</RedStatusMessage>;
    case 'COMPLETED':
      return <BlueStatusMessage>{`${t('completed')}`}</BlueStatusMessage>;
    case 'FAILED':
      return <RedStatusMessage>{`${t('failed')}`}</RedStatusMessage>;
    case 'RESERVED':
      return <BlueStatusMessage>{`${t('reserved')}`}</BlueStatusMessage>;
  }
};
